var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Loader } from '../../components';
import { useHttp } from '../../hooks/useHttp';
import { useMessage } from '../../hooks/useMessage';
import styles from './styles.module.scss';
import { AVN, EllipseMl, EllipseRb, EllipseRt } from '../../img';
import { useTypeDispatch } from '../../hooks/useTypeDispatch';
import { authSlice } from '../../redux/reducers/AuthSlice';
import { useTranslation } from 'react-i18next';
const AuthPage = () => {
    const toast = useMessage();
    const { t } = useTranslation();
    const dispatch = useTypeDispatch();
    const { accessAuth } = authSlice.actions;
    const { request, loader } = useHttp();
    const [isPassword, setIsPassword] = React.useState(false);
    const [form, setForm] = React.useState({
        login: '',
        password: ''
    });
    const change = (e) => {
        setForm(Object.assign(Object.assign({}, form), { [e.target.name]: e.target.value }));
    };
    const loginApi = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        const { login, password } = form;
        if (login.length && password.length) {
            const { data, auth, type, message } = yield request('/auth/login', 'POST', {
                login: login.trim(),
                password: password.trim()
            });
            toast(message, type);
            if (auth) {
                dispatch(accessAuth({
                    id_user: data.id_user,
                    id_avn_user: data.id_avn_user,
                    id_role: data.id_role,
                    isAuth: auth
                }));
            }
        }
    });
    React.useEffect(() => {
        const valueInput = localStorage.getItem('form') || null;
        if (valueInput) {
            const p = JSON.parse(valueInput);
            setForm(p);
        }
    }, []);
    return (_jsxs("div", Object.assign({ className: styles.container }, { children: [_jsx("img", { src: EllipseRt, alt: "rt", className: styles.rt }), _jsx("img", { src: EllipseMl, alt: "ml", className: styles.ml }), _jsx("img", { src: EllipseRb, alt: "rb", className: styles.rb }), _jsx("img", { src: AVN, alt: "avn", className: styles.avn }), _jsx("div", Object.assign({ className: styles.auth }, { children: _jsxs("form", { children: [_jsx("h1", Object.assign({ className: "text-center" }, { children: t('auth.auth') })), _jsxs("div", Object.assign({ className: `${styles.content} ${styles.content_first}` }, { children: [_jsx("label", Object.assign({ htmlFor: "login", className: styles.label }, { children: t('auth.login') })), _jsx("input", { required: true, value: form.login, name: "login", id: "login", placeholder: t('auth.login'), onChange: change }), _jsx("i", { className: "fa fa-user" })] })), _jsxs("div", Object.assign({ className: styles.content }, { children: [_jsx("label", Object.assign({ htmlFor: "password", className: styles.label }, { children: t('auth.password') })), _jsx("input", { required: true, value: form.password, name: "password", type: isPassword ? 'text' : 'password', onChange: change, id: "password", placeholder: t('auth.password') }), _jsx("i", { onClick: setIsPassword.bind(null, !isPassword), className: `fa-solid ${isPassword ? 'fa-eye' : 'fa-eye-slash'}` })] })), _jsx("button", Object.assign({ onClick: loginApi, disabled: loader }, { children: loader ? _jsx(Loader, { sm: true }) : t('auth.welcome') }))] }) }))] })));
};
export default AuthPage;
